import {
  DISCOUNT_EXPERIMENT_FR,
  EXPERIMENT_VARIATION,
} from 'shared/experiments/consts'
import { useGetExperiment } from 'shared/experiments/utils/experiments'

export const useGetIsDiscountEnabled = ({
  customUsecases,
}: {
  customUsecases: boolean
}): boolean => {
  const experiment = useGetExperiment(DISCOUNT_EXPERIMENT_FR)

  if (!experiment.isEnabled) {
    return true
  }

  return experiment.variant !== EXPERIMENT_VARIATION.V1 && customUsecases
}
